import React from "react";
import Typography from "@material-ui/core/Typography";

const CustomInputLabel = ({ label }) => {
  return <Typography color={"textSecondary"}>{label}</Typography>;
};

export default CustomInputLabel;
